import { Message, Modal } from '@metaarchit/govmo-web-ui';
// import { getErrorMessage } from '@metaarchit/common-utils/lib/error';
function getErrorMessage(err, localeFn = (key) => key) {
  if (err instanceof Error) {
    const { code, response } = err;
    console.log('=====', code);
    if (code !== 'ERR_BAD_RESPONSE') {
      if (code) {
        return localeFn(code, err);
      }
    }
    if (response) {
      const { code, message } = response.data;
      return localeFn(`${ code || message}`, err);
    }
  }
  return localeFn(String((err && err.message) || err), err);
}
export default {
  install(Vue, { i18n }) {
    Vue.prototype.$confirm = function ({
      title = i18n.t('MessagePlugin.title.tips'),
      message,
      confirmButtonText = i18n.t('MessagePlugin.action.confirm'),
      cancelButtonText = i18n.t('MessagePlugin.action.cancel'),
    }) {
      return new Promise((resolve, reject) => {
        Modal.confirm({
          title,
          okText: confirmButtonText,
          cancelText: cancelButtonText,
          keyboard: false,
          content: message,
          onOk: () => resolve(),
          onCancel: () => reject(),
        });
      });
    };

    Vue.prototype.$alert = function ({
      title = i18n.t('MessagePlugin.title.tips'),
      message,
      confirmButtonText = i18n.t('MessagePlugin.action.confirm'),
    }) {
      return new Promise((resolve) => {
        Modal.warning({
          title,
          okText: confirmButtonText,
          keyboard: false,
          content: message,
          onOk: () => resolve(),
        });
      });
    };

    Vue.prototype.$identifyAlert = function ({
      title = i18n.t('MessagePlugin.title.tips'),
      message,
      confirmButtonText = i18n.t('MessagePlugin.action.confirm'),
    }) {
      let modalInstance = null;

      const promise = new Promise((resolve) => {
        modalInstance = Modal.warning({
          title,
          okText: confirmButtonText,
          keyboard: false,
          content: message,
          onOk: () => resolve(),
        });
      });

      return {
        promise,
        close: () => {
          modalInstance && modalInstance.destroy();
        },
      };
    };

    Vue.prototype.$errorMessage = function (error) {
      console.log('====error', error);

      const errorCodeMessageKey = 'ERROR_CODE_MESSAGE.';
      return typeof error === 'string'
        ? error
        : getErrorMessage(error, (key) =>
            i18n.t(`${errorCodeMessageKey}${key}`).replace(errorCodeMessageKey, ''),
          );
    };

    Vue.prototype.$error = function (error) {
      const message = Vue.prototype.$errorMessage(error);
      Message.error(message);
    };

    Vue.prototype.$showLoading = function () {
      Vue.prototype.$loading();
    };

    Vue.prototype.$hideLoading = function () {
      Vue.prototype.$loading(false);
    };
  },
};
